/**
 * Lemonaid Firestoren `/admin/kirjanpitajien-roolit` -dokumentin URI:t.
 * Jaettu kaikkien projektien kesken (lemonator-functions, lemonaid-functions, lemonator-angular)
 * yhden totuudenlähteen vuoksi.
 */
export class KirjanpitajienRoolitUriService {
  annaKirjanpitajienRoolitUri(): string {
    return 'admin/kirjanpitajien-roolit'
  }
}
